
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'2-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            회원 관리 - 회원 {{ $route.query.customer_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.customer_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_division'>가입구분<span class="pointTextRed">(수정불가)</span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_division'
                readonly
                v-model="formData.customerDivisionName"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_super_status'>관리자계정 여부</label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="customer_super_status"
                v-model="formData.customerSuperStatus"
              >
                <option value='0'>일반회원</option>
                <option value='1'>관리자</option>
              </select>
            </div>
          </div>

          <div
            class="Admin_PageDetail_BoxWrap"
            v-if="formData.customerDivision === 1"
          >
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_login_ID'>로그인 ID<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='customer_login_ID'
                maxLength="20"
                placeholder = "아래 내용 확인 후 로그인 ID를 입력해 주세요."
                v-model="formData.customerLoginID"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.customerLoginIDError}}</p>
          </div>

          <div
            class="Admin_PageInfo pdl15 mgb40"
            v-if="formData.customerDivision === 1"
          >
            <p>로그인 ID 입력 안내</p>
            <p>1. 아이디는 최소 6자 이상 입력해야 합니다.</p>
            <p>2. 한글 및 특수문자는 입력할 수 없습니다.</p>
          </div>

          <div
            class="Admin_PageDetail_BoxWrap"
            v-if="formData.customerDivision === 1"
          >
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_password'>로그인 비밀번호</label>
              <input
                class="Admin_PageDetail_inputText"
                type='password'
                id = 'customer_password'
                maxLength="20"
                placeholder = "아래 내용 확인 후 비밀번호를 입력해 주세요."
                v-model="formData.customerPassword"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.customerPasswordError}}</p>
          </div>

          <div
            class="Admin_PageInfo pdl15 mgb40"
            v-if="formData.customerDivision === 1"
          >
            <p>로그인 비밀번호 입력 안내</p>
            <p>1. 수정 시 비밀번호 변경이 필요하면 변경할 비밀번호를 입력 후 수정하면 됩니다.</p>
            <p>2. 수정 시 비밀번호 변경이 필요하지 않다면 빈칸으로 수정하면 됩니다.</p>
            <p>3. 비밀번호는 최소 8자리/ 숫자, 특수문자 각 1회 이상으로 설정해야 합니다.</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_name'>회원명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_name'
                maxLength="20"
                placeholder = "회원명을 입력해 주세요."
                v-model="formData.customerName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.customerNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_phone_number'>전화번호<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_phone_number'
                maxLength="13"
                placeholder = "전화번호를 입력해 주세요."
                v-model="formData.customerPhoneNumber"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.customerPhoneNumberError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_email'>이메일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_email'
                maxLength="50"
                placeholder = "이메일을 입력해 주세요."
                v-model="formData.customerEmail"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.customerEmailError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_gender'>성별<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="customer_gender"
                v-model="formData.customerGender"
              >
                <option value='0'>미등록</option>
                <option value='1'>남자</option>
                <option value='2'>여자</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_zip_code'>우편번호(클릭)<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                id = 'customer_zip_code'
                v-model="formData.customerZipCode"
                maxlength="10"
                placeholder="클릭 시 검색"
                readonly
                v-on:click="search_address"
              />
            </div>
            <p class="Admin_ErrorBox"></p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_road_address'>도로명 주소(클릭)<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                id = 'customer_road_address'
                v-model="formData.customerRoadAddress"
                maxlength="150"
                placeholder="클릭 시 검색"
                readonly
                v-on:click="search_address"
              />
            </div>
            <p class="Admin_ErrorBox"></p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_detail_address'>상세 주소</label>
              <input
                class="Admin_PageDetail_inputText"
                id = 'customer_detail_address'
                v-model="formData.customerDetailAddress"
                maxlength="150"
                placeholder="상세주소를 입력해주세요."
              />
            </div>
            <p class="Admin_ErrorBox"></p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_activate'>활성화 여부</label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="customer_activate"
                v-model="formData.customerActivate"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_service_agreement_status'>서비스 동의 여부</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_service_agreement_status'
                readonly
                :value="formData.customerServiceAgreementStatus === 0 ? '미동의' : '동의(' + formData.customerServiceAgreementDate + ')'"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_privacy_status'>개인정보 동의 여부</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_privacy_status'
                readonly
                :value="formData.customerPrivacyStatus === 0 ? '미동의' : '동의(' + formData.customerPrivacyDate + ')'"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_privacy_status'>마케팅 동의 여부</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_privacy_status'
                readonly
                :value="formData.customerMarketingStatus === 0 ? '미동의' : '동의(' + formData.customerMarketingDate + ')'"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_secession_reason'>탈퇴사유</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_secession_reason'
                readonly
                :value="formData.customerActivate === 2 ? formData.customerSecessionReason : ''"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_secession_date'>탈퇴일자</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'customer_secession_date'
                readonly
                :value="formData.customerActivate === 2 ? formData.customerSecessionDate : ''"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='point_log_point'>보유포인트</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'point_log_point'
                readonly
                :value="statusData.pointLogPoint"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for="point_log_point_add">포인트 부여(차감) 금액</label>
              <input
                class="Admin_PageDetail_inputText"
                type="text"
                id="point_log_point_add"
                maxlength="13"
                v-model="formData.pointLogPoint"
                @input="formData.pointLogPoint = formData.pointLogPoint.replace(/[^0-9\-]/g, '')"
              />
            </div>
            <button class="Admin_PageDetail_Btn" v-on:click="pointAdd">포인트 부여(차감) 하기</button>
          </div>

          <div
            class="Admin_PageInfo pdl15 mgb40"
          >
            <p>포인트 부여(차감) 안내</p>
            <p>1. 금액을 입력 후 포인트 부여(차감) 하기 버튼을 누르시면 됩니다.</p>
            <p>2. 차감금액은 앞에 -기호를 넣어서 입력하시면 됩니다.</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_customer_one,
  update_customer,
  check_customer_login_ID,
  add_point
} from '../../ETC/Axios.vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword,
  validateKorEng,
  removeWhitespacePhone,
  validatePhone,
  validateEmail
} from '../../ETC/Validation.vue'

export default {
  name: 'AdminCustomerManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner

  },
  setup () {
    return {
      formData: ref({
        customerDivision: 1,
        customerDivisionName: '',
        customerSuperStatus: '0',
        customerLoginID: '',
        customerPassword: '',
        customerName: '',
        customerPhoneNumber: '',
        customerEmail: '',
        customerGender: 0,
        customerZipCode: '',
        customerRoadAddress: '',
        customerDetailAddress: '',
        customerBigArea: '',
        customerSmallArea: '',
        customerActivate: 1,
        customerServiceAgreementDate: '',
        customerServiceAgreementStatus: 0,
        customerPrivacyDate: '',
        customerPrivacyStatus: 0,
        customerMarketingDate: '',
        customerMarketingStatus: 0,
        customerSecessionReason: '',
        customerSecessionDate: '',
        pointLogPoint: '0'
      }),
      errorData: ref({
        customerLoginIDError: '',
        customerPasswordError: '',
        customerNameError: '',
        customerPhoneNumberError: '',
        customerEmailError: ''
      }),
      statusData: ref({
        customerLoginStatus: false,
        customerPasswordStatus: true,
        customerNameStatus: false,
        customerPhoneNumberStatus: false,
        customerEmailStatus: true,
        spinnerStatus: false,
        pointLogPoint: '0'
      })
    }
  },
  watch: {
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      check_customer_login_ID(removeWhitespace(value)).then(result => {
        if (result === 0) {
          if (removeWhitespace(value) === '') {
            this.errorData.customerLoginIDError = '로그인 ID는 필수로 입력하셔야 합니다.'
            this.statusData.customerLoginStatus = false
          } else if (removeWhitespace(value).length < 5) {
            this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력하셔야 합니다.'
            this.statusData.customerLoginStatus = false
          } else if (validateEngNum(removeWhitespace(value))) {
            this.errorData.customerLoginIDError = ''
            this.statusData.customerLoginStatus = true
          } else {
            this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
            this.statusData.customerLoginStatus = false
          }
        } else if (this.formData.customerLoginID === this.$route.query.customer_login_ID) {
          this.errorData.customerLoginIDError = ''
          this.statusData.customerLoginStatus = true
        } else {
          this.errorData.customerLoginIDError = '중복된 아이디가 있습니다.'
          this.statusData.customerLoginStatus = false
        }
      })
    },
    'formData.customerPassword': function (value) {
      this.formData.customerPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else {
        this.errorData.customerPasswordError = '최소 8자리 / 숫자, 특수문자 각 1회 이상을 입력하셔야 합니다.'
        this.statusData.customerPasswordStatus = false
      }
    },
    'formData.customerName': function (value) {
      this.formData.customerName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerNameError = '고객명은 필수로 입력하셔야 합니다.'
        this.statusData.customerNameStatus = false
      } else if (removeWhitespace(value).length < 2) {
        this.errorData.customerNameError = '고객명은 최소 2자이상 입력하셔야 합니다.'
        this.statusData.customerNameStatus = false
      } else if (validateKorEng(removeWhitespace(value))) {
        this.errorData.customerNameError = ''
        this.statusData.customerNameStatus = true
      } else {
        this.errorData.customerNameError = '한글 및 영문만 입력하셔야 합니다.'
        this.statusData.customerNameStatus = false
      }
    },
    'formData.customerPhoneNumber': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.customerPhoneNumber = removeWhitespacePhone(cleanValue)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.customerPhoneNumberError = '전화번호는 필수로 입력하셔야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.customerPhoneNumberError = ''
        this.statusData.customerPhoneNumberStatus = true
      } else {
        this.errorData.customerPhoneNumberError = '전화번호는 휴대폰번호 형식으로 입력하셔야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      }
    },
    'formData.customerEmail': function (value) {
      this.formData.customerEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerEmailError = ''
        this.statusData.customerEmailStatus = true
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.customerEmailError = ''
        this.statusData.customerEmailStatus = true
      } else {
        this.errorData.customerEmailError = '이메일 형식으로 입력하셔야 합니다.'
        this.statusData.customerEmailStatus = false
      }
    }
  },
  methods: {
    pointAdd () {
      this.statusData.spinnerStatus = true
      const pointValue = parseFloat(this.formData.pointLogPoint.replace(/,/g, '')) || 0
      const currentPoint = parseFloat(this.statusData.pointLogPoint.replace(/,/g, '')) || 0
      const updatedPoint = currentPoint + pointValue
      add_point(
        this.$route.query.customer_ID,
        pointValue
      ).then(() => {
        this.statusData.spinnerStatus = false
        this.statusData.pointLogPoint = updatedPoint.toLocaleString()
        this.formData.pointLogPoint = '0'
        alert('완료되었습니다.')
      })
    },
    search_address: function () {
      new window.daum.Postcode({
        oncomplete: (data) => {
          this.formData.customerZipCode = data.zonecode
          this.formData.customerRoadAddress = data.roadAddress === '' ? data.autoRoadAddress : data.roadAddress
          this.formData.customerDetailAddress = data.buildingName
          this.formData.customerBigArea = data.sido
          this.formData.customerSmallArea = data.sigungu
        }
      }).open()
    },
    check_form: function () {
      if (
        this.statusData.customerLoginStatus &&
        this.statusData.customerPasswordStatus &&
        this.statusData.customerNameStatus &&
        this.statusData.customerPhoneNumberStatus &&
        this.statusData.customerEmailStatus
      ) {
        this.statusData.spinnerStatus = true
        update_customer(
          this.$route.query.customer_ID,
          this.formData.customerSuperStatus,
          this.formData.customerLoginID,
          this.formData.customerPassword,
          this.formData.customerName,
          this.formData.customerPhoneNumber,
          this.formData.customerEmail,
          this.formData.customerGender,
          this.formData.customerZipCode,
          this.formData.customerRoadAddress,
          this.formData.customerDetailAddress,
          this.formData.customerBigArea,
          this.formData.customerSmallArea,
          this.formData.customerActivate
        ).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
          window.location.href = '/AdminCustomerManagement'
        })
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.customer_ID !== undefined) {
      get_customer_one(this.$route.query.customer_ID).then((result) => {
        this.formData.customerDivision = result[0].customer_division
        this.formData.customerSuperStatus = result[0].customer_super_status
        this.formData.customerDivisionName = result[0].customer_division_name
        this.formData.customerLoginID = result[0].customer_login_ID
        this.formData.customerName = result[0].customer_name
        this.formData.customerPhoneNumber = result[0].customer_phone_number
        this.formData.customerEmail = result[0].customer_email
        this.formData.customerGender = result[0].customer_gender
        this.formData.customerZipCode = result[0].customer_zip_code
        this.formData.customerRoadAddress = result[0].customer_road_address
        this.formData.customerDetailAddress = result[0].customer_detail_address
        this.formData.customerBigArea = result[0].customer_big_area
        this.formData.customerSmallArea = result[0].customer_small_area
        this.formData.customerActivate = result[0].customer_activate
        this.formData.customerServiceAgreementDate = result[0].customer_service_agreement_date
        this.formData.customerServiceAgreementStatus = result[0].customer_service_agreement_status
        this.formData.customerPrivacyDate = result[0].customer_privacy_date
        this.formData.customerPrivacyStatus = result[0].customer_privacy_status
        this.formData.customerMarketingDate = result[0].customer_marketing_date
        this.formData.customerMarketingStatus = result[0].customer_marketing_status
        this.formData.customerSecessionReason = result[0].customer_secession_reason
        this.formData.customerSecessionDate = result[0].customer_secession_date
        this.statusData.pointLogPoint = result[0].point_log_point.toLocaleString()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CustomerManagement/AdminCustomerManagementAdd.vue